import React from 'react';
import Layout from '../components/layout/Layout';
import { Gallery } from '../components/gallery';

const GalleryPage: React.FC = () => {
  return (
    <Layout>
      <div className="bg-light">
        <div className="container mx-auto px-4 py-16">
          <h1 className="text-4xl font-black mb-6 text-black">Gallery</h1>
          <p className="text-lg mb-10 text-gray-700">Explore our collection of mural artwork below.</p>
          <Gallery />
        </div>
      </div>
    </Layout>
  );
};

export default GalleryPage;